'use client';
import { ErrorBoundary } from '@benzinga/core-ui';
import { ClientNewsListElement } from '../../_components/markets/ClientNewsListElement';
import { BlockLayout } from './BlockLayout';
import type { StoryObject } from '@benzinga/advanced-news-manager';

interface LatestNewsSideWidgetProps {
  news: StoryObject[];
}

export const LatestNewsSideWidget = ({ news }: LatestNewsSideWidgetProps) => {
  return (
    <ErrorBoundary name="latest-news">
      <BlockLayout
        title="Latest News"
        actionLabel="See More"
        actionLink="/recent"
        headerClassName="!px-0"
        variant="clean"
      >
        <div className="flex flex-col divide-y divide-gray-200 md:max-h-[500px]">
          {news?.map(item => (
            <ClientNewsListElement
              className="!px-0 !py-2"
              key={`latest-news-side-widget_news-item-${item.id}`}
              article={item}
              showFull={false}
              showTicker={false}
            />
          ))}
        </div>
      </BlockLayout>
    </ErrorBoundary>
  );
};

export default LatestNewsSideWidget;
